<template>
  <register-layout :title="$t('사용자 정보 입력')" @close="onClickClose" @prev="onClickPrev" @next="onClickNext">
    <div class="register-form grid grid-cols-2 items-start">
      <input-form class="col-span-2" label="회사명" :error-message="error.사업장">
        <div class="" :style="isDangerFieldInput ? 'border: 1px solid #ff0000; border-radius: 6px;' : ''">
          <vs-select class="w-full" v-model="register.field" :options="fieldOptions" autocomplete :placeholder="$t('회사를 선택해주세요.')">
            <vs-select-item v-for="item in fieldOptions" :key="item.id" :value="item" :text="item.field_name" />
          </vs-select>
        </div>
      </input-form>

      <!-- 업체 검색 관련-->
      <div class="col-span-2">
        <input-form
          v-show="!isRegistCompany"
          class="col-span-2"
          label="사업자등록번호"
          :is-success="isCheckedCompany && isRegistCompany"
          :success-message="isCheckedCompany && isRegistCompany ? '등록된 업체입니다.' : ''"
          :errorMessage="error.업체"
        >
          <label class="w-full" style="display: grid; grid-template-columns: 1fr auto; gap: 0.675rem">
            <ml-input
              class="w-full"
              placeholder="사업자등록번호 10자리 숫자를 입력해주세요."
              v-model="사업자등록번호_검색"
              :danger="isDangerCompanyInput"
              @input="formatBusinessNumber"
              @change="
                () => {
                  isCheckedCompany = false;
                  isRegistCompany = false;
                  error.업체 = '';
                  register.업체 = {};
                }
              "
              :max="12"
            />
            <vs-button class="input-button py-0 px-3" color="secondary" type="border" @click="onClickFindCompany" :disabled="!(!isCheckedCompany && validateCompanyCode)">{{ $t("업체검색") }}</vs-button>
          </label>
        </input-form>

        <!-- 업체검색 결과 -->
        <div class="col-span-2" v-show="isRegistCompany">
          <label class="w-full my-2" style="display: grid; grid-template-columns: 1fr 1fr auto; gap: 0.675rem">
            <ml-input class="w-full" placeholder="업체명을 입력해주세요." v-model="register.업체.com_name" readonly />
            <ml-input class="w-full" placeholder="사업자등록번호 10자리를 입력해주세요." v-model="register.업체.com_number" readonly />
            <feather-icon icon="XIcon" style="align-self: center" @click="onClickRemoveCompany" />
          </label>
        </div>
      </div>

      <input-form class="col-span-2" label="아이디" :is-success="confirmAccountDuplicate" :success-message="confirmAccountDuplicate ? '사용 가능한 아이디입니다.' : ''" :errorMessage="error.accountInput">
        <label class="w-full" style="display: grid; grid-template-columns: 1fr auto; gap: 0.675rem">
          <ml-input
            class="w-full"
            placeholder="아이디를 입력해주세요."
            v-model="register.accountInput"
            :danger="isDangerAccountInput"
            @change="
              () => {
                if (confirmAccountDuplicate) {
                  confirmAccountDuplicate = false;
                  error.accountInput = '아이디를 중복확인을 해주세요.';
                }
              }
            "
            autocomplete="off"
            :max="20"
          />
          <vs-button class="input-button py-0 px-3" color="secondary" type="border" @click="onClickDuplicationCheck">{{ $t("중복확인") }}</vs-button>
        </label>
      </input-form>

      <input-form class="col-span-2" label="비밀번호" :errorMessage="error.passwordInput">
        <ml-input class="w-full" type="password" placeholder="영문 대문자, 소문자, 숫자, 특수문자 포함 8~16자" v-model="register.passwordInput" :danger="isDangerPasswordInput" />
      </input-form>

      <input-form class="col-span-2" label="비밀번호 재확인" :errorMessage="error.rePasswordInput">
        <ml-input class="w-full" type="password" placeholder="비밀번호를 입력해주세요." v-model="rePasswordInput" :danger="isDangerRePasswordInput" />
      </input-form>

      <input-form class="col-span-2" label="내국인/외국인">
        <radio-group
          class="col-span-4 my-2"
          flex
          :items="[
            { label: '내국인', value: false },
            { label: '외국인', value: true },
          ]"
          :row-count="2"
          v-model="register.foreign"
        />
      </input-form>

      <input-form class="col-span-2 md:col-span-1" label="이름" :error-message="error.name">
        <ml-input class="w-full" placeholder="이름을 입력해주세요." v-model="register.name" :danger="isDangerNameInput" />
      </input-form>

      <input-form class="col-span-2 md:col-span-1" :label="register.foreign ? '외국인등록번호(앞 7자리 한정)' : '주민등록번호(앞 7자리 한정)'" :error-message="error.rrn">
        <div class="flex align-center gap-2">
          <ml-input ref="residentId1" class="w-full" v-model="residentId1" @input="inputRRN('residentId2')" :danger="isDangerRRNInput1" :max="6" />
          <span>-</span>
          <ml-input ref="residentId2" v-model="residentId2" @input="inputRRN()" :danger="isDangerRRNInput2" :max="1" style="width: 50px" />
          <span>******</span>
        </div>
      </input-form>

      <input-form class="col-span-2" label="휴대폰번호" :errorMessage="error.phone">
        <div class="flex align-center gap-2">
          <ml-input ref="phonePart1" class="w-full" v-model="phonePart1" @input="inputPhone('phonePart1', 'phonePart2')" :danger="isDangerPhoneInput" :max="3" />
          <span>-</span>
          <ml-input ref="phonePart2" class="w-full" v-model="phonePart2" @input="inputPhone('phonePart2', 'phonePart3')" :danger="isDangerPhoneInput" :max="4" />
          <span>-</span>
          <ml-input ref="phonePart3" class="w-full" v-model="phonePart3" @input="inputPhone()" :danger="isDangerPhoneInput" :max="4" />
          <vs-button class="input-button py-0 px-3 whitespace-no-wrap" style="align-self: start; min-width: 110px" color="secondary" type="border" @click="onClickGetPhoneAuth">{{ $t("인증번호 전송") }}</vs-button>
        </div>
      </input-form>

      <div v-show="isShowPhoneAuth" class="col-span-2">
        <input-form :is-success="confirmPhoneAuth" :success-message="confirmPhoneAuth ? '인증이 완료되었습니다.' : ''" :error-message="error.phoneAuth">
          <div style="display: grid; grid-template-columns: 1fr auto; gap: 0.675rem">
            <ml-input class="w-full" placeholder="인증번호 입력" v-model="phoneAuth" :danger="isDangerPhoneAuthInput" style="grid-column: 1 / span 1; grid-row: 1 / span 1" :readonly="confirmPhoneAuth" />
            <vs-button v-show="!confirmPhoneAuth" class="input-button py-0 px-3" color="secondary" type="border" style="grid-column: 2 / span 1; grid-row: 1 / span 1" @click="onClickCheckPhoneAuth">{{ $t("인증확인") }}</vs-button>
          </div>
        </input-form>
      </div>

      <input-form class="col-span-2" label="이메일(선택)">
        <ml-input class="w-full" placeholder="이메일을 입력해주세요." v-model="register.email" />
      </input-form>
    </div>
  </register-layout>
</template>

<script>
import RegisterLayout from "@/views/pages/register/RegisterLayout.vue";
import InputForm from "@/views/pages/register/InputForm.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "RegisterForm",
  components: {
    RadioGroup,
    InputForm,
    RegisterLayout,
  },
  computed: {
    // 검증
    isDangerFieldInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.fieldInput) {
        return false;
      }

      // field가 없거나, 빈 객체이거나, id가 없거나 빈 경우 체크
      if (!this.register.field || Object.keys(this.register.field).length === 0 || !this.register.field.id) {
        this.error.사업장 = "사업장을 선택해주세요.";
        return true;
      }

      this.error.사업장 = "";
      return false;
    },

    isDangerCompanyInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.companyInput) {
        return false;
      }

      if (!this.사업자등록번호_검색) {
        this.error.업체 = "사업자등록번호를 입력해주세요.";
        return true;
      }

      if (!this.validateCompanyCode) {
        this.error.업체 = "유효한 사업자등록번호를 입력해주세요.(10자리 숫자)";
        return true;
      }

      if (!this.isCheckedCompany) {
        this.error.업체 = "업체를 검색해주세요.";
        return true;
      }

      if (!this.isRegistCompany) {
        this.error.업체 = "등록되지 않은 업체입니다. 관리담당자에게 문의해주세요.";
        return true;
      }

      this.error.업체 = "";
      return false;
    },

    isDangerAccountInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.accountInput) {
        return false;
      }

      if (!this.validateAccountInput) {
        this.error.accountInput = "아이디는 4~20자의 영문 대소문자, 숫자만 입력 가능합니다.";
        return true;
      }

      if (!this.confirmAccountDuplicate) {
        this.error.accountInput = "아이디를 중복확인을 해주세요.";
        return true;
      }

      this.error.accountInput = "";
      return false;
    },

    isDangerPasswordInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.passwordInput) {
        return false;
      }

      if (!this.register.passwordInput) {
        this.error.passwordInput = "비밀번호를 입력해주세요.";
        return true;
      }

      if (!this.validatePasswordInput) {
        this.error.passwordInput = "비밀번호는 영문 대문자, 소문자, 숫자, 특수문자 포함 8~16자를 입력해주세요";
        return true;
      }

      this.error.passwordInput = "";
      return false;
    },

    isDangerRePasswordInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.passwordInput) {
        return false;
      }

      if (this.register.passwordInput !== this.rePasswordInput) {
        this.error.rePasswordInput = "비밀번호가 일치하지 않습니다.";
        return true;
      }

      this.error.rePasswordInput = "";
      return false;
    },

    isDangerNameInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.nameInput) {
        return false;
      }

      if (!this.register.name) {
        this.error.name = "이름을 입력해주세요.";
        return true;
      }

      this.error.name = "";
      return false;
    },

    isDangerRRNInput1() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.rrnInput) {
        return false;
      }

      if (!this.residentId1) {
        this.error.rrn = this.register.foreign ? "외국인등록번호를 입력해주세요." : "주민등록번호를 입력해주세요.";
        return true;
      }

      if (!this.validateDateFormat) {
        this.error.rrn = "유효한 연월일을 입력해주세요.";
        return true;
      }

      // 만 20세 미만 체크
      if (this.residentId1 && this.validateDateFormat) {
        const birthYear = parseInt(this.residentId1.substring(0, 2));
        const birthMonth = parseInt(this.residentId1.substring(2, 4));
        const birthDay = parseInt(this.residentId1.substring(4, 6));

        const today = new Date();
        let fullBirthYear = birthYear;

        // 2000년도 이전 출생자는 1900년대, 이후 출생자는 2000년대
        if (birthYear < 100) {
          // 00~99 사이의 숫자일 때
          // 현재 연도의 끝 두 자리 값을 구함 (예: 2023년이면 23)
          const currentYearLastTwoDigits = today.getFullYear() % 100;

          // 입력된 연도가 현재 연도보다 크다면 1900년대 출생으로 판단
          // 예: 85는 23보다 크므로 1985년으로 판단
          if (birthYear > currentYearLastTwoDigits) {
            fullBirthYear = 1900 + birthYear;
          } else {
            // 그렇지 않으면 2000년대 출생으로 판단
            // 예: 15는 23보다 작으므로 2015년으로 판단
            fullBirthYear = 2000 + birthYear;
          }
        }

        const birthDate = new Date(fullBirthYear, birthMonth - 1, birthDay);

        // 만 나이 계산
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }

        if (age < 20) {
          this.error.rrn = "만 20세 미만은 가입을 할수 없습니다";
          return true;
        }
      }

      this.error.rrn = "";
      return false;
    },

    isDangerRRNInput2() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.rrnInput) {
        return false;
      }

      if (!this.residentId2) {
        this.error.rrn = this.register.foreign ? "외국인등록번호를 입력해주세요." : "주민등록번호를 입력해주세요.";
        return true;
      }

      if (!this.validateResidentId2) {
        this.error.rrn = this.register.foreign ? "유효한 외국인등록번호를 입력해주세요." : "유효한 주민등록번호를 입력해주세요.";
        return true;
      }

      // 내국인 경우 2000년대 이후 출생자 검사
      if (!this.register.foreign) {
        if (this.residentId1 && this.residentId1.length === 6) {
          const birthYear = parseInt(this.residentId1.substring(0, 2));
          const currentYear = new Date().getFullYear() % 100; // 현재 연도의 마지막 두 자리

          // 00년부터 현재 연도까지는 2000년대 출생으로 간주
          if (birthYear >= 0 && birthYear <= currentYear) {
            // 2000년대 출생자는 주민번호 뒷자리가 3 또는 4여야 함
            if (this.residentId2 !== "3" && this.residentId2 !== "4") {
              this.error.rrn = "유효한 주민등록번호를 입력해주세요.";
              return true;
            }
          }
        }
      }

      if (!this.isDangerRRNInput1) {
        this.error.rrn = "";
      }
      return false;
    },

    isDangerPhoneInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.phoneInput) {
        return false;
      }

      if (this.register.phone.length !== 11 && this.register.phone.length !== 10) {
        this.error.phone = "휴대폰번호를 입력해주세요.";
        return true;
      }

      this.error.phone = "";
      return false;
    },

    isDangerPhoneAuthInput() {
      // 시작시 에러메세지 표시되지 않도록
      if (this.errorGuard.phoneAuthInput) {
        return false;
      }

      if (!this.phoneAuth) {
        this.error.phoneAuth = "인증번호를 입력해주세요.";
        return true;
      }

      this.error.phoneAuth = "";
      return false;
    },

    // 사업자등록번호 유효성 검사 (true: 통과)
    validateCompanyCode() {
      // Check if the length is exactly 12 characters (including hyphens)
      if (this.사업자등록번호_검색.length !== 12) {
        return false;
      }

      // Check if the format matches the pattern xxx-xx-xxxxx where x is a digit
      const regex = /^\d{3}-\d{2}-\d{5}$/;
      if (!regex.test(this.사업자등록번호_검색)) {
        return false;
      }

      return true;
    },

    // 아이디 유효성 검사 (true: 통과)
    validateAccountInput() {
      if (this.register.accountInput === "") {
        return false;
      }

      // 4~20자의 영문 대소문자, 숫자만 입력 가능
      const regex = /^[A-Za-z0-9]{4,20}$/;
      if (!regex.test(this.register.accountInput)) {
        return false;
      }

      return true;
    },

    // 비밀번호 유효성 검사 (true: 통과)
    validatePasswordInput() {
      if (this.register.passwordInput === "") {
        return false;
      }

      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,16}$/;
      // const regex = /^\S{8,16}$/; // 공백을 제외한 8~16자
      if (!regex.test(this.register.passwordInput)) {
        return false;
      }

      return true;
    },

    // 주민등록번호 앞자리 유효성 검사 (true: 통과)
    validateDateFormat() {
      if (this.residentId1.length !== 6) {
        return false;
      }

      const regex = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12][0-9]|3[01]))$/;
      if (!regex.test(this.residentId1)) {
        return false;
      }

      return true;
    },

    // 주민등록번호 뒷자리 유효성 검사 (true: 통과)
    validateResidentId2() {
      if (this.residentId2.length !== 1) {
        return false;
      }

      const validNumbers = ["1", "2", "3", "4", "5", "6", "7", "8"];
      return validNumbers.includes(this.residentId2);
    },
  },
  props: {
    register: {
      type: Object,
      default: () => ({
        accountInput: "",
        passwordInput: "",
        foreign: false,
        name: "",
        rrn: "",
        phone: "",
        verifiedPhone: "",
        email: "",
        address: { home_zip: "", home_address_1: "", home_address_2: "" },
        field: {},
        업체: {},
      }),
    },
    registerType: { type: String, default: "" },
  },
  data() {
    return {
      fieldOptions: [],

      confirmAccountDuplicate: false, // 아이디 중복확인
      rePasswordInput: "", // 비밀번호 확인
      isCheckedCompany: false, // 업체 확인
      isRegistCompany: false, // 등록된 업체 유무
      사업자등록번호_검색: "", // 업체 검색용

      residentId1: "", // 주민등록번호 앞자리
      residentId2: "", // 주민등록번호 뒷자리 (1자리)
      phonePart1: "",
      phonePart2: "",
      phonePart3: "",
      phoneAuth: "", // 핸드폰 인증번호
      isExistPhone: true, // 핸드폰 중복여부
      isShowPhoneAuth: false, // 핸드폰 인증번호 입력창 표시
      confirmPhoneAuth: false, // 핸드폰 인증번호 확인

      error: {
        사업장: "",
        업체: "",
        accountInput: "",
        passwordInput: "",
        rePasswordInput: "",
        name: "",
        rrn: "",
        phone: "",
        phoneAuth: "",
      },

      // 처음에 에러메시지를 보여주지 않기 위함
      errorGuard: {
        fieldInput: true,
        companyInput: true,
        accountInput: true,
        passwordInput: true,
        nameInput: true,
        rrnInput: true,
        phoneInput: true,
        phoneAuthInput: true,
      },
    };
  },
  async created() {
    console.log("created");
    await this.loadFieldList();
  },
  methods: {
    inputRRN(nextRef) {
      this.register.rrn = `${this.residentId1}${this.residentId2}`;

      // 주민등록번호 앞자리 입력이 완료되면 다음 입력창으로 포커스 이동
      if (nextRef && this.residentId1.length === 6) {
        const nextInput = this.$refs[nextRef].$el.querySelector("input");
        nextInput.focus();
      }
    },
    inputPhone(currentRef, nextRef) {
      this.register.phone = `${this.phonePart1}${this.phonePart2}${this.phonePart3}`;
      this.confirmPhoneAuth = false;

      // 휴대폰번호 입력이 완료되면 다음 입력창으로 포커스 이동
      if (currentRef === "phonePart1" && this["phonePart1"].length === 3) {
        const nextInput = this.$refs[nextRef].$el.querySelector("input");
        nextInput.focus();
      } else if (nextRef && this[currentRef].length === 4) {
        const nextInput = this.$refs[nextRef].$el.querySelector("input");
        nextInput.focus();
      }
    },

    onClickClose() {
      this.$emit("close");
    },
    onClickPrev() {
      this.$emit("prev");
    },
    onClickNext() {
      if (this.validateForm()) {
        this.$emit("next");
      }
    },
    onClickDuplicationCheck() {
      if (!this.validateAccountInput) {
        return;
      }

      if (this.confirmAccountDuplicate) {
        return;
      }

      this.loadAccountDuplicate();
    },
    // 핸드폰 인증번호 발송
    async onClickGetPhoneAuth() {
      if (this.register.phone.length !== 11 && this.register.phone.length !== 10) {
        return;
      }
      // 핸드폰 번호 체크
      if (this.isDangerPhoneInput) {
        return;
      }
      this.confirmPhoneAuth = false;

      // 핸드폰 번호 중복 체크 (25.04.21)
      await this.loadPhoneDuplicate();
      if (this.isExistPhone) {
        return;
      }

      await this.loadGetPhoneAuth();
    },
    // 핸드폰 인증번호 확인
    onClickCheckPhoneAuth() {
      // 핸드폰 번호 체크
      if (this.isDangerPhoneInput) {
        return;
      }

      this.loadCheckPhoneAuth();
    },
    onClickFindCompany() {
      if (!this.validateCompanyCode) {
        return;
      }

      this.loadCompanyInfo();
    },
    // 확인된 사업자정보 취소 삭제
    onClickRemoveCompany() {
      this.사업자등록번호_검색 = "";
      this.register.업체 = {};
      this.isCheckedCompany = false;
      this.isRegistCompany = false;
    },

    // 사업장명 검색
    async loadFieldList() {
      await HttpRequest.get("/api/v1/field/pub")
        .then((response) => {
          if (response) {
            this.fieldOptions = response[0].fields.map((data) => {
              return {
                id: data.id,
                field_name: data.field_name,
              };
            });
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 아이디 중복확인
    async loadAccountDuplicate() {
      await HttpRequest.get("/api/v1/user/pending/exists", {
        params: {
          username: this.register.accountInput,
        },
      })
        .then((response) => {
          if (response) {
            const exist = response.exist;
            if (exist) {
              this.error.accountInput = "이미 사용중인 아이디입니다.";
            }

            this.confirmAccountDuplicate = !exist;
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 업체 검색
    async loadCompanyInfo() {
      await HttpRequest.get("/api/v1/company/pub", {
        params: {
          bnum: this.사업자등록번호_검색,
        },
      })
        .then((response) => {
          if (response) {
            console.log("response", response);
            if (response && response.data && response.data.length > 0) {
              this.register.업체 = response.data[0];
              this.isRegistCompany = true;
            } else {
              this.isRegistCompany = false;
            }

            this.isCheckedCompany = true;
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    // 인증번호 전송전 휴대폰번호 중복확인
    async loadPhoneDuplicate() {
      await HttpRequest.get("/api/v1/user/phone/exists", {
        params: {
          phone: this.register.phone,
        },
      })
        .then((response) => {
          if (response) {
            console.log("response", response);
            const exist = response.exist;
            if (exist) {
              this.error.phone = "이미 사용중인 휴대폰번호입니다.";
              this.isExistPhone = true;
            } else {
              this.isExistPhone = false;
              this.error.phone = "";
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("err", err);
            if (err.response.data) {
              this.error.phone = err.response.data.message;
            }
          }
        });
    },

    // 인증번호 전송
    async loadGetPhoneAuth() {
      await HttpRequest.post("/api/v1/user/verification/sms", {
        phone: this.register.phone,
      })
        .then((response) => {
          if (response) {
            console.log("response", response);
            this.error.phone = "";
            this.isShowPhoneAuth = true;
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("err", err);
            if (err.response.data) {
              this.error.phone = err.response.data.message;
            }
          }
        });
    },
    // 인증번호 확인
    async loadCheckPhoneAuth() {
      await HttpRequest.post("/api/v1/user/verification/sms/confirm", {
        phone: this.register.phone,
        code: this.phoneAuth,
      })
        .then((response) => {
          if (response) {
            console.log("response", response);
            if (response.message) {
              this.confirmPhoneAuth = true;
              this.register.verifiedPhone = response.verified_code;
              this.error.phoneAuth = "";
            }
          }
        })
        .catch((err) => {
          if (err.response) {
            console.log("err", err.response);
            if (err.response.data) {
              // 기존에 인증된 상태
              if (err.response.status === 409) {
                console.log("err.response.status", err.response.status);
                this.error.phoneAuth = err.response.data.message;
                this.confirmPhoneAuth = true;
                return;
              }

              this.confirmPhoneAuth = false;
              this.error.phoneAuth = err.response.data.message;
              this.register.verifiedPhone = "";
            }
          }
        });
    },

    warningMessage(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "필수 항목을 입력해주세요!",
          message: msg ? msg : "입력되지 않은 필수 항목이 있습니다.<br/>" + "모든 필수 항목을 입력한 후 다시 시도해주세요. 감사합니다.",
          cancelBtn: "확인",
        },
      });
      window.dispatchEvent(customAlert);
    },

    // errorGuard 아이템 중 하나라도 true가 있는 경우 true를 반환
    checkErrorGuard() {
      // 각 errorGuard 값들을 로그로 출력
      console.log("fieldInput:", this.errorGuard.fieldInput); // 사업장
      console.log("companyInput:", this.errorGuard.companyInput); // 업체
      console.log("accountInput:", this.errorGuard.accountInput); // 아이디
      console.log("passwordInput:", this.errorGuard.passwordInput); // 비밀번호
      console.log("nameInput:", this.errorGuard.nameInput); // 이름
      console.log("rrnInput:", this.errorGuard.rrnInput); // 주민등록번호
      console.log("phoneInput:", this.errorGuard.phoneInput); // 휴대폰번호
      console.log("phoneAuthInput:", this.errorGuard.phoneAuthInput); // 인증번호

      return Object.values(this.errorGuard).some((value) => value);
    },

    // 최종검증
    validateForm() {
      if (this.checkErrorGuard()) {
        for (const key in this.errorGuard) {
          this.errorGuard[key] = false;
        }

        this.warningMessage(); // 공통 경고메세지
        return false;
      }

      const checkFieldInputValid = !this.isDangerFieldInput; // 사업장
      const checkCompanyInputValid = !this.isDangerCompanyInput; // 업체
      const checkAccountInputValid = !this.isDangerAccountInput; // 아이디
      const checkPasswordInputValid = !this.isDangerPasswordInput; // 비밀번호
      const checkRePasswordInputValid = !this.isDangerRePasswordInput; // 비밀번호 재확인
      const checkNameInputValid = !this.isDangerNameInput; // 이름
      const checkRRNInput1Valid = !this.isDangerRRNInput1; // 주민등록번호 앞자리
      const checkRRNInput2Valid = !this.isDangerRRNInput2; // 주민등록번호 뒷자리
      const checkPhoneInputValid = !this.isDangerPhoneInput; // 휴대폰번호

      // 검증 실패시
      if (
        !checkFieldInputValid ||
        !checkCompanyInputValid ||
        !checkAccountInputValid ||
        !checkPasswordInputValid ||
        !checkRePasswordInputValid ||
        !checkNameInputValid ||
        !checkRRNInput1Valid ||
        !checkRRNInput2Valid ||
        !checkPhoneInputValid
      ) {
        this.warningMessage(); // 공통 경고메세지
        return false;
      }

      if (!this.confirmAccountDuplicate) {
        this.warningMessage("아이디 중복확인을 해주세요.");
        return false;
      }
      if (!this.confirmPhoneAuth) {
        console.log("confirmPhoneAuth", this.confirmPhoneAuth);
        if (this.isShowPhoneAuth) {
          this.error.phoneAuth = "휴대폰 인증번호를 확인해주세요.";
          this.warningMessage(this.error.phoneAuth);
        } else {
          this.error.phone = "휴대폰번호를 인증해주세요.";
          this.warningMessage(this.error.phone);
        }
        return false;
      }

      return true;
    },
    formatBusinessNumber(value) {
      // 숫자와 하이픈만 입력 허용
      let formattedValue = value.replace(/[^0-9-]/g, "");

      // 하이픈 제거
      formattedValue = formattedValue.replace(/-/g, "");

      // 10자리 숫자인 경우에만 포맷팅
      if (formattedValue.length === 10) {
        formattedValue = formattedValue.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
      }

      // 최대 12자리(하이픈 포함)로 제한
      formattedValue = formattedValue.slice(0, 12);

      // 값 업데이트
      // this.사업자등록번호_검색 = formattedValue;
      this.$nextTick(() => {
        this.사업자등록번호_검색 = formattedValue;
      });
    },
  },
  // input-icon-validate 클래스를 가진 엘리먼트에 대해 MutationObserver를 이용하여 자식 엘리먼트가 추가될 때마다 display: none 처리
  mounted() {
    this.$nextTick(() => {
      const iconElements = this.$el.querySelectorAll(".input-icon-validate");
      iconElements.forEach((iconElement) => {
        iconElement.style.display = "none";
      });

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (node.classList && node.classList.contains("input-icon-validate")) {
                node.style.display = "none";
              }
            });
          }
        });
      });

      observer.observe(this.$el, { childList: true, subtree: true });
    });
  },
  watch: {
    "register.field": {
      handler() {
        if (this.errorGuard.fieldInput) {
          this.errorGuard.fieldInput = false;
        }
      },
    },
    사업자등록번호_검색: {
      handler() {
        if (this.errorGuard.companyInput) {
          this.errorGuard.companyInput = false;
        }
      },
    },
    "register.accountInput": {
      handler() {
        if (this.errorGuard.accountInput) {
          this.errorGuard.accountInput = false;
        }
      },
    },
    "register.passwordInput": {
      handler() {
        if (this.errorGuard.passwordInput) {
          this.errorGuard.passwordInput = false;
        }
      },
    },
    rePasswordInput: {
      handler() {
        if (this.errorGuard.passwordInput) {
          this.errorGuard.passwordInput = false;
        }
      },
    },
    "register.name": {
      handler() {
        if (this.errorGuard.nameInput) {
          this.errorGuard.nameInput = false;
        }
      },
    },
    residentId1: {
      handler() {
        if (this.errorGuard.rrnInput) {
          this.errorGuard.rrnInput = false;
        }
      },
    },
    residentId2: {
      handler() {
        if (this.errorGuard.rrnInput) {
          this.errorGuard.rrnInput = false;
        }
      },
    },
    phonePart1: {
      handler() {
        if (this.errorGuard.phoneInput) {
          this.errorGuard.phoneInput = false;
        }
      },
    },
    phonePart2: {
      handler() {
        if (this.errorGuard.phoneInput) {
          this.errorGuard.phoneInput = false;
        }
      },
    },
    phonePart3: {
      handler() {
        if (this.errorGuard.phoneInput) {
          this.errorGuard.phoneInput = false;
        }
      },
    },
    phoneAuth: {
      handler() {
        if (this.errorGuard.phoneAuthInput) {
          this.errorGuard.phoneAuthInput = false;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss">
.register-form {
  gap: 1rem;
}
.align-center {
  align-items: center;
}
.input-button {
  height: 37.5px;
}
</style>
